import React from 'react'
import { Modal } from '@components/ui'

type MessageCenterDeleteContactModalProps = {
  show: boolean
  contactName: string
  onCancel: () => void
  onDelete: () => void
}

const MessageCenterDeleteContactModal: React.FC<
  MessageCenterDeleteContactModalProps
> = ({ show, contactName, onCancel, onDelete }) => {
  const name = contactName.trim() || 'this contact'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title="Delete contact"
      description={`Are you sure you want to delete ${name}? You can add them back anytime.`}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default MessageCenterDeleteContactModal
